export default __webpack_public_path__ + "static/transparent-pixel.781fe655549cf48d07bd64607d01ee23.png";